<template>
	<div class="rt">
		<div class="box-max">
			<div class="control cl-left ">
				<img class="box-bg zoomInOut-element" src="../../assets/template/control-left.png" alt="">
				<div class="cl-left-text ">
					<span class="cl-left-text-num">{{ defaultdata[0].value2 || '' }}</span>
					<span class="cl-left-text-unit">{{ defaultdata[0].value3 || '' }}</span>
					<p class="ellipsis" style="width:60px" :title="defaultdata[0].value1">{{ defaultdata[0].value1 || ''
					}}</p>
				</div>
			</div>
			<div class="control cl-center">
				<div class="cl-center-Top"></div>
			</div>
			<div class="control cl-right ">
				<img class="box-bg zoomInOut-element" src="../../assets/template/control-right.png" alt="">
				<div class="cl-right-text ">
					<span class="cl-right-text-num">{{ defaultdata[1].value2 || '' }}</span>
					<span class="cl-right-text-unit">{{ defaultdata[1].value3 || '' }}</span>
					<p class="ellipsis" style="width:60px" :title="defaultdata[1].value1">{{ defaultdata[1].value1 || ''
					}}</p>
				</div>
			</div>
		</div>
		<img class="box-bg Rotating rotateXZ-element" src="../../assets/template/control.png" alt="">
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope4',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			defaultdata: [
				{ value1: '系列一', value2: '60', value3: '%' },
				{ value1: '系列二', value2: '40', value3: '%' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
				{ name: '单位', key: "value3" },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {}
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		}
	},
	beforeDestroy() {
	},
	methods: {
		...methods,
	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
	},
};
</script>

<style scoped lang="scss">
@font-face {
	font-family: "Source Han Sans CN";
	src: url("../../assets/fonts/SourceHanSansCN-Medium.woff2");
}

@font-face {
	font-family: "Benmo-Ziyu";
	src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

/* 旋转360 */
@keyframes rotateXZ {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}

.rotateXZ-element {
	animation: rotateXZ 4s linear infinite;
}

.rt {
	width: 435px;
	height: 240px;
	padding: 10px 0;
	display: flex;
	position: relative;
	overflow: hidden;
}


.box-max {
	margin: 0 auto;
	width: 94%;
	height: 100%;
	display: flex;
	position: relative;
	justify-content: space-between;
	align-items: center;
	z-index: 5;
}

.box-bg {
	width: 210px;
	height: 210px;

}

.control img {
	width: 114px;
	height: 196px;
	z-index: 1;

}

.cl-left {
	width: 114px;
	height: 196px;
	display: flex;

	.cl-left-text {
		position: relative;
		height: 200px;
		top: calc(100% - 118px);
		left: calc(0% - 85px);
		z-index: 60 !important;

		&-num {
			display: inline-block;

			font-family: Benmo-Ziyu;
			font-weight: 400;
			font-size: 20px;
			color: #FFFFFF;
			line-height: 15px;
		}

		&-unit {

			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-left: 3px
		}

		p {

			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-top: 12px;
		}
	}

}

.cl-center {
	width: 76px;
	height: 76px;
	border-radius: 50%;
	border: 1px solid #004ADB;
	position: relative;


	.cl-center-Top {
		width: 38px;
		height: 34px;
		background: url('@/assets/template/xiaoshoue.png') no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 50;
	}
}

.cl-right {
	width: 114px;
	height: 196px;
	display: flex;

	.cl-right-text {
		position: relative;
		top: calc(100% - 118px);
		left: calc(0% - 75px);
		z-index: 60 !important;

		&-num {
			display: inline-block;

			font-family: Benmo-Ziyu;
			font-weight: 400;
			font-size: 20px;
			color: #FFFFFF;
			line-height: 15px;
		}

		&-unit {

			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-left: 2px;
		}

		p {


			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #8FAAF7;
			line-height: 15px;
			margin-top: 12px;
		}
	}


}


.Rotating {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	z-index: 1;
}
</style>